import { apiService } from '../services/api';
import { useAuthStore } from '../stores/authStore';
import { getProfileCompletion } from './profileCompletion';

export async function redirectAfterAuth(navigate, fallbackPath = '/') {
  try {
    const [profileRes, addressesRes] = await Promise.all([
      apiService.getProfile(),
      apiService.getAddresses().catch(() => ({ data: [] })),
    ]);

    const user = profileRes?.data ?? profileRes;
    const addresses = addressesRes?.data ?? addressesRes ?? [];
    const list = Array.isArray(addresses) ? addresses : [];

    if (user && typeof user === 'object') {
      useAuthStore.getState().updateUser(user);
    }

    const { isComplete } = getProfileCompletion(user, list);

    if (!isComplete) {
      navigate('/profile?complete=1', { replace: true });
      return;
    }

    navigate(fallbackPath, { replace: true });
  } catch {
    navigate(fallbackPath, { replace: true });
  }
}
